'use strict';

var $ = require('jquery');
var colorbox = require('../lib/plaudit.colorbox.js');
var siteLightboxOptions = require('./siteLightboxOptions.js');

function lightboxAjaxFormLoad(href) {
	var fullHtml = '';
	$.ajax({
		url: href,
		success: function (data) {
			var $data = $('#lightboxContent', data);
			//*tst*/console.log(data);
			fullHtml = '<div id="' + $data.attr('id') + '" class="' + $data.attr('class') + '">';
			$data.each(function () {
				var html = $(this).html();
				if (typeof html === 'string') {
					fullHtml += html;
				}
			});
			fullHtml = fullHtml + '</div>'
		},
		async: false
	});
	return fullHtml;
}
function lightboxAjaxResponse() {
	var formLightbox = require('./formLightbox.js');
	//*tst*/console.log('on:cbox_complete');
	$.colorbox.resize();
	formLightbox.init();
}

$(document).on('cbox_complete', function () {
	lightboxAjaxResponse();
});
$(document).on('jsfAjaxEvent', function (event) {
	if (event.detail.fireType === "always") {
		lightboxAjaxResponse();
	}
});

function init() {
	var selectors = [
		'a[href*="create-listing.html"]',
		'a[href*="sign-up.html"]',
		'a[href*="designated-buyer-operations.html"]',
		'a[href*="login.html"]',
		'a[href*="forgot-login.html"]',
		'a[data-require-login]'
	];
	var $elem = $(selectors.join());
	if ($elem.length === 0) {
		return;
	}
	var options = $.extend({}, siteLightboxOptions.options(), {
		html: function () {
			return siteLightboxOptions.load($(this).attr('href'));
		}
	});

	$(selectors.join()).colorbox(options);
}


module.exports = {
	init: init
}
